(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  function syncDecoForgeRequest(select) {
    const form = select.closest('form');
    const model = select.value === 'Custom Model Request';
    const bulk = select.value === 'Bulk Order Request';
    const modelFields = form.querySelector('[data-model-fields]');
    const bulkFields = form.querySelector('[data-bulk-fields]');
    modelFields.hidden = !model;
    modelFields.querySelector('input').required = model;
    bulkFields.hidden = !bulk;
    bulkFields.querySelectorAll('input[type="text"],input[type="number"]').forEach((input) => {
      input.required = bulk && input.name !== 'contact[Colors and customization]';
    });
  }
  function initializeDecoForgeRequests() {
    document.querySelectorAll('[data-request-inquiry]').forEach(syncDecoForgeRequest);
  }
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-request-inquiry]')) syncDecoForgeRequest(event.target);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeDecoForgeRequests);
  else initializeDecoForgeRequests();
  document.addEventListener('shopify:section:load', initializeDecoForgeRequests);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["decoforge-featured-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('decoforge-reviews')) {
  customElements.define('decoforge-reviews', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-review]')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.controls = this.querySelector('.df-reviews__controls');
      this.controls.hidden = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.stopped = this.dataset.autoplay !== 'true' || this.reducedMotion.matches;
      this.querySelector('[data-next]').addEventListener('click', () => { this.show(this.index + 1); this.restart(); }, options);
      this.querySelector('[data-previous]').addEventListener('click', () => { this.show(this.index - 1); this.restart(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.restart(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.restart(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.restart(); }, options);
      this.addEventListener('focusout', () => { queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.restart(); }); }, options);
      document.addEventListener('visibilitychange', () => this.restart(), options);
      this.reducedMotion.addEventListener('change', () => { this.stopped = this.dataset.autoplay !== 'true' || this.reducedMotion.matches; this.restart(); }, options);
      document.addEventListener('shopify:block:select', event => { const n = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId); if (n >= 0) this.show(n); }, options);
      this.restart();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.querySelector('[data-position]').textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    restart() {
      clearInterval(this.timer);
      if (!this.stopped && !this.hovered && !this.focused && !document.hidden) this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.delay) || 12000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["decoforge-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["decoforge-quote-requests"]) return;
  try {
    
  function initializeQuotePicker(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const rows = [...root.querySelectorAll('[data-picker-item]')];
    const search = root.querySelector('[data-picker-search]');
    const type = root.querySelector('[data-picker-type]');
    const price = root.querySelector('[data-picker-price]');
    const filter = () => {
      const words = search.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      let count = 0;
      rows.forEach((row) => {
        const cents = Number(row.dataset.price);
        const priceOK = !price.value || (price.value === 'low' ? cents < 1000 : price.value === 'mid' ? cents >= 1000 && cents < 2500 : cents >= 2500);
        const matches = words.every((word) => row.dataset.search.includes(word)) && (!type.value || row.dataset.type === type.value) && priceOK;
        row.hidden = !matches;
        if (matches) count++;
      });
      root.querySelector('[data-picker-count]').textContent = count + ' ' + JSON.parse(document.querySelector('[data-picker-labels]').textContent).count;
      root.querySelector('[data-picker-empty]').hidden = count !== 0;
    };
    [search,type,price].forEach((field) => field.addEventListener('input', filter));
    filter();
    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-pick-product]');
      if (!button) return;
      const panel = root.closest('[data-quote-panel]');
      panel.querySelector('[data-selected-title]').value = button.dataset.title;
      panel.querySelector('[data-selected-id]').value = button.dataset.id;
      panel.querySelector('[data-selected-url]').value = new URL(button.dataset.url, window.location.origin).href;
      panel.querySelector('[data-bulk-submit]').disabled = false;
      root.querySelectorAll('[data-pick-product]').forEach((candidate) => candidate.setAttribute('aria-pressed', candidate === button ? 'true' : 'false'));
      panel.querySelector('input[name="contact[Quantity]"]').focus();
    });
  }
  function initializeQuoteFlow() {
    document.querySelectorAll('[data-product-picker]').forEach(initializeQuotePicker);
    if (!document.getElementById('quote-top')) return;
    const targets = ['print-estimate','bulk-request','model-request','find-your-next-print'];
    const update = () => {
      const hashId = decodeURIComponent(window.location.hash.slice(1));
      let active = targets.includes(hashId) ? hashId : '';
      if (hashId.startsWith('QuoteRequest-')) active = hashId.includes('-bulk-') ? 'bulk-request' : 'model-request';
      targets.forEach((id) => { const el = document.getElementById(id); if (el) el.hidden = id !== active; });
      const target = document.getElementById(active || 'quote-top');
      if (window.location.hash && target) requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
    };
    if (!document.documentElement.dataset.quoteFlowReady) {
      document.documentElement.dataset.quoteFlowReady = 'true';
      window.addEventListener('hashchange', update);
    }
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeQuoteFlow);
  else initializeQuoteFlow();
  document.addEventListener('shopify:section:load', initializeQuoteFlow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
